import * as z from 'zod';

import { DateString, NonNegativeMonetaryValue } from '../fields';

/**
 * One row of a NACHA Returns spreadsheet. Operators use this to bulk-fail
 * outgoing transactions when the bank sends back a Return file. The
 * (batchDate, fileIdModifier, traceNumber) triple uniquely identifies a
 * transaction; `amount` is a redundant safety check against the wrong file
 * being uploaded.
 */
export const FailNachaPaymentsRow = z.object({
  batchDate: DateString,
  fileIdModifier: z.string().min(1).max(1),
  traceNumber: z.string().regex(/^\d{15}$/, 'Trace number must be exactly 15 digits'),
  returnCode: z
    .string()
    .regex(/^[rR]\d{2}$/, 'Return code must be in the form R## (e.g. R01)')
    .transform((v) => v.toUpperCase()),
  amount: NonNegativeMonetaryValue,
});
export type FailNachaPaymentsRow = z.infer<typeof FailNachaPaymentsRow>;

export const FAIL_NACHA_PAYMENTS_ROW_REQUIRED_FIELDS = Object.keys(FailNachaPaymentsRow.shape).filter(
  (key) => !FailNachaPaymentsRow.shape[key as keyof typeof FailNachaPaymentsRow.shape].isOptional(),
);
